var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-ss-plus",
    clipPath: "url(#clip0_1510_63463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 9.17703H10.8425V0.0195312H9.17752V9.17703H0.0200195V10.842H9.17752V19.9995H10.8425V10.842H20V9.17703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1510_63463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.98,
    height: 19.98,
    fill: "white",
    transform: "translate(0.0200195 0.0195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f6d18f6e189974ce072ce9da361d52a0.svg";
export { ForwardRef as ReactComponent };